import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_EQUIPMENT,
  API_CREATE_EQUIPMENT,
  API_LOAD_EQUIPMENTS,
  API_REMOVE_EQUIPMENT,
  API_UPDATE_EQUIPMENT,
  REMOVE_LOCAL_EQUIPMENT,
} from './equipment.reducer';

export const load = () => ({ resourceAction: API_LOAD_EQUIPMENTS });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_EQUIPMENT,
  resource,
} : { resourceAction: API_UPDATE_EQUIPMENT, resource });
export const add = () => ({ type: ADD_LOCAL_EQUIPMENT });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_EQUIPMENT,
  id,
} : { resourceAction: API_REMOVE_EQUIPMENT, id });



// WEBPACK FOOTER //
// ./src/reducers/equipment/equipment.actions.js